import PropTypes from 'prop-types';
// @flow

import React from 'react';
import _ from 'lodash';

import { Restaurant } from 'PMT/entities';
import { OrderSettings } from 'PMT/entities/order';

//
// components
//
import AbstractOrderSettingsForm from './AbstractOrderSettingsForm';
import OpeningHoursForDay from 'components/openingHours/OpeningHoursForDay';
import AddOpeningHourModal from 'components/openingHours/AddOpeningHourModal';
import OpeningHoursForm from 'components/openingHours/OpeningHoursForm';
import { SecurityContext } from 'utils';

export default class OrderGeneralSettingsPage extends AbstractOrderSettingsForm {

  canEditOpeningHours(): boolean {
    return SecurityContext.orderSettings.canEditOpeningHours();
  }

  // We override the parent class util to disable the submit button if the user
  // cannot edit opening hours (instead of whole order settings canEdit check).
  shouldDisableSubmit(): boolean {
    return !this.canEditOpeningHours();
  }

  // We override the parent class submit event to prevent submit if the user
  // cannot edit opening hours (instead of whole order settings canEdit check).
  onSubmit = (event: Event) => {
    if (this.canEditOpeningHours()) {
      this.props.onSubmit(this.orderSettings);
    }
  };

  static propTypes = {
    restaurant: PropTypes.instanceOf(Restaurant),

    orderSettings: PropTypes.instanceOf(OrderSettings),

    onSubmit: PropTypes.func.isRequired
  };

  state = this.getDefaultState(this.props.orderSettings);

  //
  // events opening hours
  //

  onOpeningHoursChange = (openingHours: OpeningHours) => {
    const orderSettings: OrderSettings = this.orderSettings;

    orderSettings.openingHours = openingHours;

    this.setState({
      orderSettings
    });
  };

  //
  // Renderers
  //

  renderBody() {
    const openingsHours: OpeningHours = this.orderSettings.openingHours;

    return (
      <div>
        <OpeningHoursForm
          openingHours={openingsHours}
          onChange={this.onOpeningHoursChange}
          readOnly={!this.canEditOpeningHours()}
        />

        {this.renderFixedButtons()}
      </div>
    );
  }

  render() {
    try {
    return (
      <div>
        {this.renderBody()}
      </div>
    );
  } catch (e) { console.error(e); }
  }

}
